import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';
import 'rxjs/Rx';

import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MdDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';

import { userRole_regionalAdmin } from '../../../Common/appConstant';
import { SharedService } from '../../../Common/Services/shared.service';
import { Enum } from '../../../utility/enum.enum';
import { AppMessage } from './../../../Common/appMessage';
import { AppGlobals } from './../../../Common/Services/app.global';
import { Utility } from './../../../Common/Services/utility';
import { AdmManageDomainComponent } from './../../../Components/adm-manage-domain/adm-manage-domain.component';
import { DialogConfirmComponentComponent } from './../../dialog-confirm-component/dialog-confirm-component.component';
import { AdmManageLocationService } from './../adm-manage-location.service';
import { AdmManageKoalaconfigComponent } from 'app/Components/adm-manage-location/adm-manage-koalaconfig/adm-manage-koalaconfig.component';
import { AppConfig } from 'app/Common/appConfiguration';

@Component({
  selector: 'app-adm-update-location',
  templateUrl: './adm-update-location.component.html',
  styleUrls: ['./adm-update-location.component.css'],
  providers: [AdmManageLocationService]
})
export class AdmUpdateLocationComponent implements OnInit {


  isEditBtnDisable: boolean;
  isSaveBtnDisable: boolean;
  title: string;
  id: number; // Primary field
  status: number = 0; // to Check Active and Retire or Pending
  resetFlag: boolean;  // Used this flag for Cascading dropdowns : Intially on page load - No cascading field should reset & After that If we change parent combo value - child should be reset
  role: string;
  addNewFlag: {
    businessCenter: boolean,
    keyboardType: boolean,
    group: boolean,
    id: number // newly added record (keyboardType, BusinessCenter or Group) Id
  }
  formControl: any;
  regionFilteredOptions: any;
  countryFilteredOptions: any;
  stateFilteredOptions: any;
  cityFilteredOptions: any;
  locationFilteredOptions: any;
  businessCenterFilteredOptions: any;
  keyboardTypeFilteredOptions: any;
  proctorGroupFilteredOptions: any;
  timeZoneOptions: any;
  form: FormGroup;
  confirmDialogMsgModel: any;
  Enum: any = Enum; // we have to use Enum in HTML file so creating a local instance of this.

  constructor(public _utility: Utility, private _admManageLocationService: AdmManageLocationService, public _appGlobals: AppGlobals, public _dialog: MdDialog
    , private _activatedRoute: ActivatedRoute, private _sharedService: SharedService, private _appMessage: AppMessage) {
    this.form = new FormGroup({
      regionId: new FormControl('', Validators.required),
      countryId: new FormControl('', Validators.required),
      address1: new FormControl('', Validators.required),
      address2: new FormControl(''),
      stateId: new FormControl('', Validators.required),
      cityId: new FormControl('', Validators.required),
      zipcode: new FormControl('', Validators.required),
      timezone: new FormControl('', Validators.required),
      keyboardTypeId: new FormControl('', Validators.required),
      locationName: new FormControl('', Validators.required),
      businessCenterId: new FormControl('', Validators.required),
      contactInfoForCandidates: new FormControl('', [Validators.required, Validators.pattern(AppConfig.phoneNumberRegEx)]),
      proctorGroupId: new FormControl('', Validators.required),
      adminName: new FormControl('', Validators.required),
      adminEmail: new FormControl('', [Validators.required, Validators.email]),
      adminPhone: new FormControl('', [Validators.required, Validators.pattern(AppConfig.phoneNumberRegEx)]),
      techName: new FormControl('', Validators.required),
      techEmail: new FormControl('', [Validators.required, Validators.email]),
      techPhone: new FormControl('', [Validators.required, Validators.pattern(AppConfig.phoneNumberRegEx)]),
      candidateInstructions: new FormControl('')
    });

    this.formControl = this.form.controls;

    this.form.valueChanges
      .debounceTime(400)
      .subscribe(form => {
        this.isSaveBtnDisable = this._utility.disableSaveUpdate(this.form);
        if (!this.form.disabled && this.form.dirty) {
          this._utility.setTxnStatus(true); // display confirm box for FORM changes
        }
      });
  }

  ngOnInit() {
    this._appGlobals.routeWithID = false;
    this.role = this._utility.getUserRole();
    this.addNewFlag = {
      businessCenter: false,
      keyboardType: false,
      group: false,
      id: 0
    }
    this.resetFlag = false;
    this._utility.clearTxnStatus(); // close confirm box for FORM changes
    this.setCombosData();
    this.readFormControlValuesChanges();

    this.confirmDialogMsgModel = {
      modelType: "CONFIRMATION",
      msgTitle: 'Are you sure?',
      isConfirmBox: true,
      confirmBtnCaption: 'Confirm',
      cancelBtnCaption: 'Cancel'
    };
  }

  /**
   * If value of control has been changed then called values changes function of that field
   */
  readFormControlValuesChanges() {

    this.formControl.regionId.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.validateInput(value, this.form.controls.regionId);
        this.regionChanges(value);
      });

    this.formControl.countryId.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.validateInput(value, this.form.controls.countryId);
        this.countryChages(value);
      });

    this.formControl.stateId.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.stateChages(value);
        this.validateInput(value, this.form.controls.stateId);
        this._utility.setTimeZone(value, this);
      });

    this.formControl.cityId.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.validateInput(value, this.form.controls.cityId);
        this._utility.setTimeZone(value, this);
      });


    this.formControl.businessCenterId.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.businessCenterChages(value);
      });

    this.formControl.keyboardTypeId.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.keyboardTypeChages(value);
      })

    this.formControl.proctorGroupId.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.proctorGroupChages(value);
      });
  }

  //show error message if user enter wrong value
  validateInput(value, control) {
    if (value && !value.id) {
      control.setErrors({ validId: true });
    }
    else if (control.errors && control.errors.validId) {
      control.errors.validId = false;
    }
  }

  /**
   * If we type text in field and that value exists already in autocomplete data then fetch that
   * else enable add new option button
   * @param value -- current value of combo field
   * @param option -- search field model Option Name
   * @param type  -- which we have used in addNewFlag object for keyboard type , business center and proctor group field
   * @param control -- that particular field control
   */
  addNewControlsValuesChanges(value: any, model: string, type: string, control: string) {
    if (value && !value.id) {
      let data = this._sharedService[model + "List"];
      if (data) {
        let item = data.filter(function (item) { if (item.name.trim().toLowerCase() == value.trim().toLowerCase()) return item });
        if (item && item.length > 0) {
          this.addNewFlag[type] = false;
          this.formControl[control].setValue(item[0]);
        } else {
          this.addNewFlag[type] = true;
        }
      } else {
        this.addNewFlag[type] = false;
      }
    } else {
      this.addNewFlag[type] = false;
    }

  }

  // When we change value of proctor group
  proctorGroupChages(value) {
    this.addNewControlsValuesChanges(value, 'proctorGroup', 'group', 'proctorGroupId');
  }

  // When we change valye of Keyboard Type combo Field , this function is called
  keyboardTypeChages(value) {
    this.addNewControlsValuesChanges(value, 'keyboardType', 'keyboardType', 'keyboardTypeId');
  }

  // When we change valye of Business Center combo Field , this function is called
  businessCenterChages(value): void {
    this.addNewControlsValuesChanges(value, 'businessCenter', 'businessCenter', 'businessCenterId');
  }

  /**
    * When we type a groupname and that value does not exists then display + icon to add a new entered value
    * This function called when click on + icon
    * Display a confirm message before save
    */
  addNewGroup() {
    let value = this.formControl.proctorGroupId.value;
    if (value && !value.id) {
      this.confirmDialogMsgModel.msg = this._appMessage.getItem['UMsg00040'];
      let confirmDialogMsgRef = this._dialog.open(DialogConfirmComponentComponent,
        {
          data: this.confirmDialogMsgModel
        });
      confirmDialogMsgRef.afterClosed().subscribe(result => {
        if (result == "1") {
          this._sharedService.saveNewEntity(value, Enum.ProctorGroup).subscribe(response => {
            this._utility.onSuccessCallback(response, this._appMessage.getItem['UMsg00030'], () => {
              this.addNewFlag.group = false; // hide + icon
              if (response && response.response.id) {
                this.addNewFlag.id = response.response.id; // set newly added record's Id in appNewFlag object
              }
              this.getCombo('proctorGroup', this.formControl.proctorGroupId, Enum.ProctorGroup);
            });
          }, error => this._utility.onErrorCallback(error));
        }
      });
    }
  }

  /**
   * After added new value in Keyboard Type, Business center or Group - call this function
   * Load data again and set in respective shared service Object
   * Get Object based on new added record Id and set that particular object in Control field
   * @param controlKey - contry key
   * @param controlName  - control
   * @param enumType  - Enum
   */
  getCombo(controlKey: string, controlName: any, enumType: number) : void {
    this._sharedService.getComboFieldsData(enumType, (response) => {
      this._sharedService[controlKey + "List"] = response.response; // set all data again in shared service
      this._utility.setDataInComboField(controlKey, null, controlName, this);
      // get object based on returned Id and set value in field
      let item = this._utility.getRecordById(controlKey, this.addNewFlag.id);
      controlName.setValue(item);
    });
  }

  /**
   * When we type a keyboard type and that value does not exists then display + icon to add a new entered value
   * This function called when click on + icon
   * Display a confirm message before save
   */
  addNewkeyboardType() {
    let value = this.formControl.keyboardTypeId.value;
    if (value && !value.id) {
      this.confirmDialogMsgModel.msg = this._appMessage.getItem['UMsg00041'];
      let confirmDialogMsgRef = this._dialog.open(DialogConfirmComponentComponent,
        {
          data: this.confirmDialogMsgModel
        });
      confirmDialogMsgRef.afterClosed().subscribe(result => {
        if (result == "1") {
          this._sharedService.saveNewEntity(value, Enum.KeyboardType).subscribe(response => {

            this._utility.onSuccessCallback(response, this._appMessage.getItem['UMsg00030'], () => {
              this.addNewFlag.keyboardType = false; // hide + icon
              if (response && response.response.id) {
                this.addNewFlag.id = response.response.id;
              }
              this.getCombo('keyboardType', this.formControl.keyboardTypeId, Enum.KeyboardType)
            });
          }, error => this._utility.onErrorCallback(error));
        }
      });
    }
  }

  // when we add new keybaord Type call this
  addNewBusinessCenter() {
    let value = this.formControl.businessCenterId.value;
    if (value && !value.id) {
      this.confirmDialogMsgModel.msg = this._appMessage.getItem['UMsg00042'];
      let confirmDialogMsgRef = this._dialog.open(DialogConfirmComponentComponent,
        {
          data: this.confirmDialogMsgModel
        });
      confirmDialogMsgRef.afterClosed().subscribe(result => {
        if (result == "1") {
          this._sharedService.saveNewEntity(value, Enum.BusinessCenter).subscribe(response => {

            this._utility.onSuccessCallback(response, this._appMessage.getItem['UMsg00030'], () => {
              this.addNewFlag.businessCenter = false; // hide + icon
              if (response && response.response.id) {
                this.addNewFlag.id = response.response.id;
              }
              this.getCombo('businessCenter', this.formControl.businessCenterId, Enum.BusinessCenter)
            });
          }, error => this._utility.onErrorCallback(error));
        }
      });
    }
  }

  // when region Changes
  regionChanges(value) {
    // Reset cascading field only when resetFlag is true
    if (this.resetFlag) {
      this.formControl.countryId.setValue('');
      this.formControl.cityId.setValue('');
      this.formControl.stateId.setValue('');
    }
    let data = [];
    if (value && value.id && this._sharedService.countryList) {
      data = this._sharedService.countryList.filter(function (item) { if (item.parentId == value.id) return item });
    }
    this._utility.setDataInComboField('country', data, this.formControl.countryId, this);
  }

  // When country value changes
  countryChages(value: any) {
    if (this.resetFlag) {
      this.formControl.stateId.setValue('');
      this.formControl.cityId.setValue('');
    }
    let data = [];
    if (value && value.id && this._sharedService.stateList) {
      data = this._sharedService.stateList.filter(function (item) { if (item.parentId == value.id) return item });
    }
    this._utility.setDataInComboField('state', data, this.formControl.stateId, this);
  }

  // Called when status value Changes
  stateChages(value: any) {
    if (this.resetFlag) {
      this.formControl.cityId.setValue('');
    }
    let data = [];
    if (value && value.id && this._sharedService.cityList) {
      data = this._sharedService.cityList.filter(function (item) { if (item.parentId == value.id) return item });
    }
    this._utility.setDataInComboField('city', data, this.formControl.cityId, this);
  }

  // This function is called from ngOnit to Load data in All Combo Fields
  // If data is already exist in service then fetch from there else hit request and fetch data
  setCombosData() {
    this._utility.addLoaderCount();
    this._utility.setDataInComboField('region', null, this.formControl.regionId, this); //null means we are not passing any data from where
    this._utility.setDataInComboField('country', null, this.formControl.countryId, this);
    this._utility.setDataInComboField('keyboardType', null, this.formControl.keyboardTypeId, this);
    this._utility.setDataInComboField('businessCenter', null, this.formControl.businessCenterId, this);
    this._utility.setDataInComboField('state', null, this.formControl.stateId, this);
    this._utility.setDataInComboField('city', null, this.formControl.cityId, this);
    this._utility.setDataInComboField('proctorGroup', null, this.formControl.proctorGroupId, this);
    this._utility.removeLoaderCount();
    this.setDataOnForm() // after load all combos set data on form IF there is location Id exists
  }

  setDataOnForm() {
    let locationId: number = this._activatedRoute.snapshot.params['locationId'];
    if (locationId != 0) {
      this.isEditBtnDisable = false;
      this.getLocationData(locationId);
      this.id = locationId;
      this.title = 'Edit Location';
      this.isSaveBtnDisable = true;

      this._utility.disableEnableForm(this.form, true);
    } else {
      this.id = 0;
      this.title = 'Add Location';
      this.isEditBtnDisable = true;
      this.isSaveBtnDisable = false;
      this.resetFlag = true;
    }
  }

  // Function to get Location Data
  getLocationData(locationId: number) {
    this._utility.addLoaderCount();
    this._admManageLocationService.getLocation(locationId).subscribe((response) => {
      this._utility.onSuccessCallback(response, null, () => {
        let data = response.response;
        let finalData = this._utility.manageFormComboData(data);
        if (finalData) {
          this.status = finalData.status;
          this.form.patchValue(finalData);
        }
      });
    }, error => this._utility.onErrorCallback(error));
  }

  onEdit() {
    this.resetFlag = true;  // This flag for Cascading combos field
    this._utility.disableEnableForm(this.form, false);
    this.isSaveBtnDisable = false; // on click  "edit" button  enable save
    this.isEditBtnDisable = true;

    if (this.role == userRole_regionalAdmin) {
      this.formControl.regionId.disable(); // IF role is regional admin then disale region field
    }
  }

  onSubmitForm() {
    this._utility.addLoaderCount();
    if (this.form.invalid) return;

    let formData = this.form.getRawValue();
    if (Number(this.id) > 0) {
      formData.id = Number(this.id);
    }
    formData = this._utility.manageFormDataforSave(formData);
    this._admManageLocationService.saveLocation(formData)
      .subscribe(data => {
        this._utility.clearTxnStatus(); // close confirm box for FORM changes
        let successMsg;
        if (this.id == 0) {
          successMsg = this._appMessage.getItem['UMsg00043'];
        } else {
          successMsg = this._appMessage.getItem['UMsg00029'];
        }
        this._utility.onSuccessCallback(data, successMsg, () => {
          if (this.id == 0) {
            this.status = Enum.StatusPending; // set status pending when add new record
          }
          this.id = data.response.id; // Update newly record Id
          this.isEditBtnDisable = false;
          this.isSaveBtnDisable = true; // on click  "edit" button  enable save
          this._utility.disableEnableForm(this.form, true);
        });

      }, error => this._utility.onErrorCallback(error));
  }


  openKoalaConfigDialog() {
    const dialogRef = this._dialog.open(AdmManageKoalaconfigComponent, {
      data: this.id
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.status = result;
      }
    });
  }

  openConfigDomain() {
    const dialogRef = this._dialog.open(AdmManageDomainComponent, {
      data: this.id
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  // When click on active or retire button
  onChangeStatus(status) {
    let message;  // this same message we have to show after success
    message = status == Enum.StatusRetire ? this._appMessage.getItem['UMsg00044'] : this._appMessage.getItem['UMsg00045'];
    let confirmDialogMsgModel = {
      modelType: "CONFIRMATION",
      msgTitle: this._appMessage.getItem['Common007'],
      msg: this._appMessage.getItem['UMsg00046'],
      isConfirmBox: true
    };
    let confirmDialogMsgRef = this._dialog.open(DialogConfirmComponentComponent,
      {
        data: confirmDialogMsgModel
      });
    confirmDialogMsgRef.afterClosed().subscribe(result => {
      if (result == "1") {
        this._utility.addLoaderCount();
        this._sharedService.changeStatus(this.id, Enum.Location, status).subscribe(response => {
          this._utility.onSuccessCallback(response, message, () => {
            this.status = status;
            if (status == Enum.StatusRetire) {
              this.isEditBtnDisable = true;
              this._utility.disableEnableForm(this.form, true);
            } else {
              this.isEditBtnDisable = false;
            }
          });
        }, error => this._utility.onErrorCallback(error));
      }
    });
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-location/adm-update-location/adm-update-location.component.ts